module.exports = __webpack_public_path__ + "static/media/GY.1e52897e.png";